export default {
  label: {
    emptyData: {
      title: 'No data available for the selected contract and bot(s)',
      description: 'Select another contract and bot in the filters to view the data.',
    },
    emptyBot: {
      title: 'Unable to load data',
      description: 'Select a bot and a contract in the filters to view the data.',
    },
    error: {
      title: '',
      description: 'Error loading data',
    },
    supportsOnlyOneBot: {
      title: 'Unable to load data',
      description: 'This component only supports selecting one bot at a time.',
    },
  },
};
